import Typography from './Typography';
import * as S from './styled/ProgressBar.styled';

/**
 * @author Burak Unsal
 * @description This component is used to show progress bar with animation
 * @param {Object} props
 * @param {number} [props.value] - Progress bar value
 * @param {string} [props.color] - Progress bar color
 * @param {"linear" | "circular"} [props.variant = 'linear'] - Progress bar variant default is linear
 * @param {string} [props.successColor] - Progress bar color when value is 100
 * @param {boolean} [props.showValue] - Show progress bar value
 * @param {"small" | "medium" | "large"} [props.thickness = 'small'] - Progress bar value thickeness
 * @example
 * <ProgressBar
 * variant="linear"
 * thickness="small"
 * value={item.percentage}
 * color="red"
 * successColor="green" />
 */
const ProgressBar = (props) => {
	const { value, color, successColor, thickness = 'small', variant = 'linear', showValue, ...restProps } = props;
	return (
		<>
			{variant === 'circular' ? (
				<S.ProgressCircle {...restProps}>
					<S.SvgContainer viewBox="0 0 120 120" className={thickness}>
						<S.Circle cx="60" cy="60" r="50" color={color || 'var(--black-10)'} value={100} />
						<S.Circle cx="60" cy="60" r="50" color={successColor || 'var(--blue)'} value={value} />
					</S.SvgContainer>
					{showValue && (
						<Typography variant="caption" className={`percentage text-${thickness}`} fontWeight="500">
							{value}%
						</Typography>
					)}
				</S.ProgressCircle>
			) : (
				<S.Container {...restProps}>
					<S.Filler
						className={thickness}
						value={value === 0 ? 0.5 : value}
						color={color}
						successColor={successColor}>
						{showValue && (
							<Typography variant="caption" className="percentage" fontWeight="500" noWrap>
								{value}%
							</Typography>
						)}
					</S.Filler>
				</S.Container>
			)}
		</>
	);
};

export default ProgressBar;
